export default __webpack_public_path__ + "static/media/i-del.1fcaa42b.svg";